import { render, staticRenderFns } from "./MarkEdit.vue?vue&type=template&id=45e2a69e&scoped=true&"
import script from "./MarkEdit.vue?vue&type=script&lang=js&"
export * from "./MarkEdit.vue?vue&type=script&lang=js&"
import style0 from "./MarkEdit.vue?vue&type=style&index=0&id=45e2a69e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e2a69e",
  null
  
)

export default component.exports